$(() => {
	
	if ($(".block-postscarousel").length > 0) {

		$(".block-postscarousel").each((i, el) => {
			let postsCarousel = $(el).find(".posts-carousel");

			const navPrev =
				'<svg xmlns="http://www.w3.org/2000/svg" width="15" height="30" viewBox="0 0 15 30" fill="none"><path d="M12.7388 30L0 15L12.7388 0L15 2.6625L4.52229 15L15 27.3375L12.7388 30Z" fill="#1C1B1F"/></svg>';
			const navNext =
				'<svg xmlns="http://www.w3.org/2000/svg" width="15" height="30" viewBox="0 0 15 30" fill="none"><path d="M2.26115 -7.93683e-07L15 15L2.26115 30L2.62826e-06 27.3375L10.4777 15L4.71102e-07 2.6625L2.26115 -7.93683e-07Z" fill="#1C1B1F"/></svg>';

			postsCarousel.owlCarousel({
				loop: false,
				nav: true,
				dots: false,
				navText: [navPrev, navNext],
				responsive: {
					0: {
						items: 1,
						margin: 0,
						autoHeight: true,
						nav: false,
						dots: true
					},
					768: {
						items: 2,
						margin: 16,
						autoHeight: false,
						nav: true,
						dots: false
					},
					992: {
						items: 3,
						margin: 16,
						nav: true,
						dots: false
					}
				},
			});
		});

	}
});
